import { render } from "./Edificio.vue?vue&type=template&id=067b2871"
import script from "./Edificio.vue?vue&type=script&lang=js"
export * from "./Edificio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__